import { Button } from "@/components/ui/button"

export default function Error() {
  return (
    <div className="flex items-center min-h-screen px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16">
      <div className="w-full space-y-6 text-center">
        <div className="space-y-3">
          <h1 className="text-4xl text-primary font-bold tracking-tighter sm:text-5xl">不明なエラーが発生しました</h1>
          <p className="font-bold text-red-500">管理者に問い合わせください。</p>
        </div>
        <Button variant="outline" onClick={() => window.location.reload()}>
          再試行
        </Button>
      </div>
    </div>
  )
}
